import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../components/ui/table"
import { Badge } from "../../../components/ui/badge"
import { Button } from "../../../components/ui/button"
import { User } from "../types/user"
import { Pencil } from "lucide-react"
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../../components/ui/tooltip"

// TODO: Replace with actual user data from API
const users: User[] = [
  {
    id: "U1001",
    email: "admin@clinic.com",
    firstName: "Admin",
    lastName: "User",
    role: "Administrator",
    permissions: {
      patients: "edit",
      visits: "edit",
      inventory: "edit",
      outreach: "edit",
      admin: true,
    },
  },
  {
    id: "U1002",
    email: "nurse@clinic.com",
    firstName: "Head",
    lastName: "Nurse",
    role: "Head Nurse",
    permissions: {
      patients: "edit",
      visits: "edit",
      inventory: "view",
      outreach: "view",
      admin: false,
    },
  },
]

function getPermissionBadge(permission: string) {
  switch (permission) {
    case "edit":
      return <Badge variant="default">View & Edit</Badge>
    case "view":
      return <Badge variant="secondary">View Only</Badge>
    default:
      return <Badge variant="outline">No Access</Badge>
  }
}

interface UserListProps {
  onEdit: (user: User) => void
}

export function UserList({ onEdit }: UserListProps) {
  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-medium leading-none tracking-tight">Current Users</h3>
        <p className="text-sm text-muted-foreground mt-2">
          List of all user accounts and their permissions
        </p>
      </div>
      
      <div className="border rounded-lg">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Email</TableHead>
              <TableHead>Role</TableHead>
              <TableHead>Patient Records</TableHead>
              <TableHead>Visits</TableHead>
              <TableHead>Inventory</TableHead>
              <TableHead>Outreach</TableHead>
              <TableHead>Admin</TableHead>
              <TableHead className="w-[100px]">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user.id}>
                <TableCell>{user.email}</TableCell>
                <TableCell>{user.role}</TableCell>
                <TableCell>{getPermissionBadge(user.permissions.patients)}</TableCell>
                <TableCell>{getPermissionBadge(user.permissions.visits)}</TableCell>
                <TableCell>{getPermissionBadge(user.permissions.inventory)}</TableCell>
                <TableCell>{getPermissionBadge(user.permissions.outreach)}</TableCell>
                <TableCell>
                  {user.permissions.admin ? (
                    <Badge>Full Access</Badge>
                  ) : (
                    <Badge variant="outline">No Access</Badge>
                  )}
                </TableCell>
                <TableCell>
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild>
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => onEdit(user)}
                  >
                    <Pencil className="h-4 w-4" />
                  </Button>
                      </TooltipTrigger>
                      <TooltipContent>
                        <p>Edit user settings</p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}
